import '@n8n/chat/style.css'
import { createChat } from '@n8n/chat'
import '/pages/chat/style.scss'
import { onDomReady, sel } from '../../utils'

export default function Chat() {
  console.log('Chat component loaded')
  const STORAGE_KEY = 'n8n-chat-session'
  function getSessionId() {
    let id = localStorage.getItem(STORAGE_KEY)
    if (!id) {
      id = crypto.randomUUID() // modern browsers
      localStorage.setItem(STORAGE_KEY, id)
    }
    return id
  }

  const _firstLoad = 'firstLoad'
  const firstLoad = localStorage.getItem(_firstLoad)
  if (!firstLoad) localStorage.setItem(_firstLoad, true)

  let sendButton = null
  // Add initial screen first
  onDomReady(() => {
    setTimeout(() => {
      const chat$ = document.getElementById('n8n-chat')
      const havbarHight = document.querySelector('.navbar').offsetHeight
      const copyHight = document.querySelector('.chat__policy').offsetHeight
      // change css variable
      chat$.style.setProperty('--vert-padding', havbarHight + copyHight + 'px')
      // console.log('Send button:', sendButton)
      setTimeout(() => {
        sendButton = sel('.chat-input-send-button')
        sendButton.replaceChildren() // Clear any existing text
        sendButton.innerText = 'Send'
        console.log('Send button:', sendButton)
      }, 1100) // Wait for n8n chat to load
      // document.addEventListener('DOMContentLoaded', function () {
      console.log('DOM loaded!')
      const chatElement = document.getElementById('n8n-chat')
      console.log('Chat element:', chatElement)

      if (!chatElement) {
        console.error('No chat element found!')
        return
      }

      // Create initial centered layout
      const initialScreen = sel('.chat__placeholder-w')

      // Handle input submission
      const initialInput = initialScreen.querySelector('.chat__input')
      const initialBtn = initialScreen.querySelector('.button')

      function submitMessage() {
        const message = initialInput.value.trim()
        if (message) {
          console.log('Message submitted:', message)

          localStorage.setItem(_firstLoad, false)

          // Hide the initial screen first
          initialScreen.style.display = 'none'
          chatElement.classList.add('has-messages')

          // Hide the chat header elements when chat starts
          setTimeout(() => {
            const chatHeader = chatElement.querySelector('.chat-header, [class*="header"]')
            if (chatHeader) {
              chatHeader.style.display = 'none'
              console.log('Chat header hidden')
            }

            // Also hide any title/subtitle elements
            const titleElements = chatElement.querySelectorAll('h1, h2, h3, [class*="title"], [class*="subtitle"]')
            titleElements.forEach((el) => {
              if (el.textContent.includes('ChatGPT') || el.textContent.includes('How can I help')) {
                el.style.display = 'none'
                console.log('Title element hidden:', el.textContent)
              }
            })
          }, 100)

          // Wait a moment for n8n interface to be visible, then send the message
          setTimeout(() => {
            // Find the n8n chat input
            const chatInput = chatElement.querySelector('textarea')
            console.log('Found chat input:', chatInput)

            if (chatInput) {
              // Set the message value
              chatInput.value = message
              chatInput.focus()

              // Trigger input events to notify n8n
              chatInput.dispatchEvent(new Event('input', { bubbles: true }))
              chatInput.dispatchEvent(new Event('change', { bubbles: true }))

              // Look for send button
              // const sendButton = chatElement.querySelector('button[type="submit"], button[aria-label*="send"], button[title*="send"]')
              console.log('Found send button:', sendButton)

              if (sendButton) {
                setTimeout(() => {
                  sendButton.click()
                }, 100)
                console.log('Send button clicked!', sendButton)
              } else {
                // Fallback: try pressing Enter
                console.log('No send button found, trying Enter key')
                chatInput.dispatchEvent(
                  new KeyboardEvent('keydown', {
                    key: 'Enter',
                    code: 'Enter',
                    bubbles: true,
                    cancelable: true,
                  })
                )
                chatInput.dispatchEvent(
                  new KeyboardEvent('keypress', {
                    key: 'Enter',
                    code: 'Enter',
                    bubbles: true,
                    cancelable: true,
                  })
                )
              }
            } else {
              console.error('Could not find n8n chat input!')
            }
          }, 300) // Increased timeout to ensure n8n is ready
        }
      }
      console.log(initialBtn)
      initialBtn.addEventListener('click', submitMessage)
      initialInput.addEventListener('keypress', function (e) {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault()
          submitMessage()
        }
      })
    }, 100)
    // Initialize n8n chat
    try {
      // console.log('n8n chat initialized!', localStorage.getItem(n8n - chat - session))
      // Check for existing session after n8n chat is initialized
    } catch (error) {
      console.error('Error initializing n8n chat:', error)
    }
    const chat = createChat({
      webhookUrl: 'https://n8n.createape.com/webhook/342d537e-b22f-4110-a0ac-b45828733a0f/chat',
      // webhookConfig: {
      //   method: 'POST',
      //   headers: {},
      // },
      target: '#n8n-chat',
      mode: 'fullscreen',
      // chatInputKey: 'chatInput',
      // chatSessionKey: STORAGE_KEY,
      // metadata: {},
      // showWelcomeScreen: false,
      // defaultLanguage: 'en',
      initialMessages: [],
      // i18n: {
      //   en: {
      //     title: 'ChatGPT',
      //     subtitle: 'How can I help you today?',
      //     footer: 'ChatGPT can make mistakes. Check important info.',
      //     getStarted: 'Start conversation',
      //     inputPlaceholder: 'Message ChatGPT...',
      //   },
      // },
      // chatSessionKey: STORAGE_KEY,
      // getSessionId,
    })
  }, 1000)
}
